<style scoped>
@media only screen and (max-width: 992px) {
  table tr td *,
  table tr th {
    font-size: 0.8em;
  }
}
</style>


<template lang="pug">
.main-content-padded.main-content-nopad-small
  .row
    .col.s12
      .bcrumb
        router-link(:to='{ name: "orders" }') Orders
        a(v-if='selectedOrder') {{ selectedOrder.referenceNumber }}
  .row(v-if='!selectedOrder')
    //- .input-field.col.s12
    //-   input#search(type='text', placeholder='Search order', v-model='searchReferenceNumber')
    //-   label.active(for='search') Reference Number
    .col.s12
      //- pre {{desserts}}

      v-app
        v-card
          v-card-title
            v-spacer
            v-text-field.sampleclass(
              v-model='search',
              append-icon='search',
              label='Search',
              single-line='',
              hide-details=''
            )
          v-data-table(
            :headers='headers',
            :items='orders',
            :pagination.sync='pagination',
            :loading='loading',
            :search='search',
            prev-icon='arrow_left',
            next-icon='arrow_right',
            sort-icon='arrow_drop_up'
          )
            //- v-progress-linear(v-slot='progress', color='blue', indeterminate)
            template(v-slot:items='props')
              td
                router-link(
                  :to='{ name: "orderByReference", params: { referenceNumber: props.item.referenceNumber } }'
                ) {{ props.item.referenceNumber }}
              td.text-xs-left {{ props.item.account.firstName }} {{ props.item.account.lastName }} ( {{ props.item.account.email }} )
              td.text-xs-left
                span(v-if='props.item.account.type === "customer"') Shopper
                span(v-else) Reseller
              td.text-xs-left
                span(v-if='props.item.paymentOption === "cash"') Cash
                span(v-else) Bank Deposit
              td.text-xs-left
                span.indigo-text(v-if='props.item.statuses["new"]')
                  i.material-icons.tooltipped(
                    data-position='bottom',
                    :data-tooltip='"New (" + props.item.statuses["new"] + ")"'
                  ) fiber_new
                span.orange-text(v-if='props.item.statuses["processing"]')
                  i.material-icons.tooltipped(
                    data-position='bottom',
                    :data-tooltip='"Processing (" + props.item.statuses["processing"] + ")"'
                  ) radio_button_checked
                span.blue-text(v-if='props.item.statuses["in-transit"]')
                  i.material-icons.tooltipped(
                    data-position='bottom',
                    :data-tooltip='"In-transit (" + props.item.statuses["in-transit"] + ")"'
                  ) directions_transit
                span.green-text(v-if='props.item.statuses["delivered"]')
                  i.material-icons.tooltipped(
                    data-position='bottom',
                    :data-tooltip='"Delivered (" + props.item.statuses["delivered"] + ")"'
                  ) check_circle
                span.red-text(v-if='props.item.statuses["declined"]')
                  i.material-icons.tooltipped(
                    data-position='bottom',
                    :data-tooltip='"Declined (" + props.item.statuses["declined"] + ")"'
                  ) do_not_disturb
                span.red-text(v-if='props.item.statuses["cancelled"]')
                  i.material-icons.tooltipped(
                    data-position='bottom',
                    :data-tooltip='"Cancelled (" + props.item.statuses["cancelled"] + ")"'
                  ) cancel
              td.text-xs-left
                span {{ props.item.createdAt | moment }}

          //- v-alert(slot='no-results', :value='true', color='error', icon='warning')
          //-   | Your search for &quot;{{ search }}&quot; found no results.
  .row(v-else)
    app-order-details(:order='selectedOrder', @orderUpdated='onOrderUpdated')
</template>
<script>
import AppOrderDetails from '@/components/app-order-details'
import axios from 'axios'
import debounce from 'debounce'
import moment from 'moment'
// import DataTable from 'vue-materialize-datatable';

export default {
  meta: {
    title: 'Orders',
  },
  data() {
    return {
      orders: [],
      orderItems: [],
      selectedOrder: null,
      searchReferenceNumber: null,
      searchListener: null,
      orderRefreshInterval: null,
      totalOrders: 0,
      desserts: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        totalItems: null,
        // sortBy: 'createdAt',
        // descending: false,
      },
      headers: [
        { text: 'Reference Number', value: 'referenceNumber', width: '20%' },
        { text: 'Sold To', value: 'account.firstName', width: '30%' },
        { text: 'Type of Member', value: 'account.firstName', width: '10%' },
        { text: 'Payment', value: 'paymentOption', width: '10%' },
        { text: 'Status', value: 'statuses', width: '10%' },
        { text: 'Date Ordered', value: 'createdAt', width: '20%' },
      ],
      search: '',
    }
  },
  created() {
    this.getOrders()
    this.getSelectedOrder()
  },
  mounted() {
    this.searchReferenceNumber = this.$route.query.referenceNumber
    this.searchListener = debounce(this.searchOrder, 1000)
    const search = document.getElementById('search')
    if (search !== null) search.addEventListener('keyup', this.searchListener)
    this.orderRefreshInterval = setInterval(this.getOrders, 300000)

    this.getDataFromApi().then((data) => {
      this.orders = data.items
      this.totalOrders = data.total
      this.pagination.totalItems = data.total
    })
  },
  updated() {
    this.$M.Tooltip.init(document.querySelectorAll('.tooltipped'))
  },
  destroyed() {
    clearInterval(this.orderRefreshInterval)
  },
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then((data) => {
          this.orders = data.items
          this.totalOrders = data.total
          this.pagination.totalItems = data.total
        })
      },
      deep: true,
    },
    '$route.params'() {
      this.getSelectedOrder()
    },
    '$route.query'() {
      // this.getOrders();
    },
  },
  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search,
      }
    },
    // sortedOrders() {
    //   return this.orders.slice(0).sort(this.orderSortFunction);
    // },
    // sortLatest() {
    //   if (
    //     this.searchReferenceNumber !== null &&
    //     this.searchReferenceNumber !== undefined
    //   ) {
    //     return this.orders.filter(order => {
    //       const rN = order.referenceNumber;
    //       return rN.includes(this.searchReferenceNumber);
    //     });
    //   }
    //   return this.orders.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    // },
    // sortedOrderItems() {
    //   return this.orderItems.slice(0).sort(this.orderItemSortFunction);
    // },
    // formatedShopperOrders() {
    //   return this.orders.map((shopper) => {
    //     let newShopperOrder = {
    //       referencenumber: shopper.referenceNumber,
    //       soldto: shopper.account.firstName + ' ' + shopper.account.lastName +'(' +shopper.account.email+ ')',
    //       typemember: shopper.account.type ,
    //       payment: shopper.paymentOption ,
    //       status: shopper.statuses ,
    //       dateOrdered: shopper.createdAt ,
    //       // birthday: shopper.account.email,
    //     }
    //     this.isLoading = false
    //     return newShopperOrder
    //   })
    // },
  },
  methods: {
    getDataFromApi() {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let search = this.search.trim().toLowerCase()

        this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
          axios
            .get(`${this.$config.API_URL}/admin/orders/`, {
              params: {
                deep: true,
                // ...this.$route.query
              },
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            })
            .then((result) => {
              let items

              items = result.data

              for (let i = 0; i < result.data.length; i++) {
                let statuses = []

                for (let j = 0; j < result.data[i].orderItems.length; j++) {
                  if (!(result.data[i].orderItems[j].status in statuses)) {
                    statuses[result.data[i].orderItems[j].status] = 1
                  } else {
                    statuses[result.data[i].orderItems[j].status]++
                  }
                }
                items[i].statuses = statuses
              }

              if (search) {
                items = items.filter((item) => {
                  return Object.values(item)
                    .join(',')
                    .toLowerCase()
                    .includes(search)
                })
              }

              if (this.pagination.sortBy) {
                items = items.sort((a, b) => {
                  const sortA = a[sortBy]
                  const sortB = b[sortBy]

                  if (descending) {
                    if (sortA < sortB) return 1
                    if (sortA > sortB) return -1
                    return 0
                  } else {
                    if (sortA < sortB) return -1
                    if (sortA > sortB) return 1
                    return 0
                  }
                })
              }

              // if (rowsPerPage > 0) {
              //   items = items.slice(
              //     (page - 1) * rowsPerPage,
              //     page * rowsPerPage
              //   )
              // }

              const total = items.length

              setTimeout(() => {
                this.loading = false
                resolve({
                  items,
                  total,
                })
              }, 300)
            })
        })
      })
    },

    moment() {
      return moment()
    },
    searchOrder() {
      this.$router.push({
        name: 'orders',
        query: { referenceNumber: this.searchReferenceNumber },
      })
    },
    orderSortFunction(orderA, orderB) {
      const fieldA = orderA['referenceNumber']
      const fieldB = orderB['referenceNumber']

      let result =
        orderA.confirmationStatus === orderB.confirmationStatus
          ? fieldA.toLowerCase() < fieldB.toLowerCase()
            ? -1
            : 1
          : orderA.confirmationStatus === 'pending'
          ? -1
          : 1
      return this.toggleSort ? result * -1 : result
    },
    orderItemSortFunction(orderItemA, orderItemB) {
      const fieldA = orderItemA['status']
      const fieldB = orderItemB['status']

      let result = 0
      result =
        fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1

      return this.toggleSort ? result * -1 : result
    },

    getOrders1() {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return axios
          .get(`${this.$config.API_URL}/admin/orders/`, {
            params: {
              deep: true,
              // ...this.$route.query
            },
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.orders = result.data

            for (let i = 0; i < result.data.length; i++) {
              let statuses = []

              for (let j = 0; j < result.data[i].orderItems.length; j++) {
                if (!(result.data[i].orderItems[j].status in statuses)) {
                  statuses[result.data[i].orderItems[j].status] = 1
                } else {
                  statuses[result.data[i].orderItems[j].status]++
                }
              }
              this.orders[i].statuses = statuses
            }
          })
      })
    },
    getOrders() {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return axios
          .get(`${this.$config.API_URL}/admin/orders/`, {
            params: {
              deep: true,
              // ...this.$route.query
            },
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.orders = result.data

            for (let i = 0; i < result.data.length; i++) {
              let statuses = []

              for (let j = 0; j < result.data[i].orderItems.length; j++) {
                if (!(result.data[i].orderItems[j].status in statuses)) {
                  statuses[result.data[i].orderItems[j].status] = 1
                } else {
                  statuses[result.data[i].orderItems[j].status]++
                }
              }
              this.orders[i].statuses = statuses
            }
          })
      })
    },
    getSelectedOrder() {
      if (!this.$route.params.referenceNumber) {
        this.selectedOrder = null
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .get(`${this.$config.API_URL}/admin/orders`, {
            params: {
              referenceNumber: this.$route.params.referenceNumber,
              deep: true,
            },
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.selectedOrder = result.data[0]
            // let modalParams = {
            //   id: 'order-details',
            //   content: AppOrderDetails,
            //   bind: {
            //     order: this.selectedOrder
            //   },
            //   onClose: this.closeOrder
            // }
            // this.$store.dispatch('modal/open', modalParams)
          })
      })
    },
    onOrderUpdated(order) {
      if (order.id === this.selectedOrder.id) {
        this.selectedOrder = Object.assign(this.selectedOrder, order)
      }
    },
    closeOrder() {
      this.selectedOrder = null
      this.$router.back()
    },
    onSupplierCreated(supplier) {},
  },
  filters: {
    moment(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },
  },
  components: {
    AppOrderDetails,
    // datatable: DataTable
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-orders.vue